import script from "./userList.vue?vue&type=script&setup=true&lang=js"
export * from "./userList.vue?vue&type=script&setup=true&lang=js"

import "./userList.vue?vue&type=style&index=0&id=c462658a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c462658a"]])

export default __exports__